import { CheckoutStatus } from '@40seas/entities/checkout';
import { Currency } from '@40seas/models';

export const MAX_AMOUNT = 1_000_000 as const;
export const MIN_AMOUNT = 5_000 as const;

export const UNSUPPORTED_CURRENCIES = [Currency.CNH];
export const TENANT_PREFIXES_WITH_COMBINED_VA = ['SHIP4WD', 'JINGSOURCING', 'E2E-TEST'];
export const SANDBOX_TENANTS = ['DEV', 'E2E-TEST', 'E2E-TEST-SANDBOX', '40SEAS-SANDBOX'];
export const AUTOMATIC_PAYOUTS_TENANTS = [
    'SHIP4WD',
    'PORTLESS',
    'ZIM',
    'MOBILENZO',
    'FRANKLY',
    'ELITE-GLOBAL-TRADING',
    'SELECT-PRO',
    'URTOPIA',
    'DISTRITECH-LLC',
    'TOPSELLER',
    'APPAREL-IMPACT',
];

export const CHECKOUT_PENDING_STATUSES = [CheckoutStatus.Pending, CheckoutStatus.Overdue];
